import BaseView from '../log-base/view';
import Suggest from '../suggest/index';

export default BaseView.extend({
	// override
	initialize: function() {
		// call BaseView constructor
		BaseView.prototype.initialize.call(this, arguments);

		this.instrumentSuggestView = new Suggest.Views.Main({
			el: '.js-instrument',
			dataUrl: '/autocomplete'
		}).render();
	},

	/**
	 * override
	 * clear instrument field as well
	 * then call base method
	 **/
	onFormReset: function(e) {
		// clear suggest
		this.instrumentSuggestView.clear();

		// call base method
		BaseView.prototype.onFormReset.apply(this, [e]);
	}
});
